import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconGoLive } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../../base/dialog/actions';
import PoojaStepsDialog from './PoojaStepsDialog';
class GoLiveButton extends AbstractButton {
    accessibilityLabel = 'Go Live';
    icon = IconGoLive;
    label = 'Go Live';
    tooltip = 'Go Live';
    _handleClick() {
        this.props.dispatch(openDialog(PoojaStepsDialog));
    }
}
export default translate(connect((_state) => ({}))(GoLiveButton));
